import { Switch as ShadcnSwitch } from '@/components/ui/Switch'; // Import your base Shadcn component
import { cn } from '@/utils';
import { cva } from 'class-variance-authority';
import * as React from 'react';

const switchVariants = cva(
    'data-[state=checked]:tw-bg-primary', // Default checked color
    {
        variants: {
            variant: {
                default: 'data-[state=checked]:tw-bg-primary',
                secondary: 'data-[state=checked]:tw-bg-secondary',
                destructive: 'data-[state=checked]:tw-bg-destructive',
                success: 'data-[state=checked]:tw-bg-green-600'
            },
            size: {
                default: 'tw-h-6 tw-w-11',
                sm: 'tw-h-5 tw-w-9'
            }
        },
        defaultVariants: {
            variant: 'default',
            size: 'default'
        }
    }
);

const Switch = React.forwardRef(
    ({ className, label, description, variant, size, id, ...props }, ref) => {
        // Generate a random ID if one isn't provided for the label association.
        // useId must run unconditionally (rules-of-hooks), so call it always
        // and only fall back to it when no id was given.
        const generatedId = React.useId();
        const switchId = id || generatedId;

        return (
            <div className="tw-flex tw-items-center tw-space-x-3">
                <ShadcnSwitch
                    className={cn(switchVariants({ variant, size }), className)}
                    id={switchId}
                    ref={ref}
                    {...props}
                />

                {(label || description) && (
                    <div className="tw-grid tw-gap-1.5 tw-leading-none">
                        {label && (
                            <label
                                className="tw-text-sm tw-font-bold tw-leading-none peer-disabled:tw-cursor-not-allowed peer-disabled:tw-opacity-70 tw-text-gray-700"
                                htmlFor={switchId}
                            >
                                {label}
                            </label>
                        )}
                        {description && (
                            <p className="tw-text-[10px] tw-text-gray-400">
                                {description}
                            </p>
                        )}
                    </div>
                )}
            </div>
        );
    }
);

Switch.displayName = 'Switch';

export { Switch };
